import { c as _c } from "react/compiler-runtime";
import type { PricingOutputDto } from "@sticker-giant/sg-frontend-common";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconChevronDown } from "@tabler/icons-react";
import type { ButtonHTMLAttributes, Ref } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { useIsCartMutating } from "@/queries/useIsCartMutating";
interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean;
  pricing: PricingOutputDto;
  ref?: Ref<HTMLButtonElement>;
}
export function OrderSummaryHeader(t0) {
  const $ = _c(22);
  let buttonProps;
  let isOpen;
  let pricing;
  let ref;
  if ($[0] !== t0) {
    ({
      isOpen,
      pricing,
      ref,
      ...buttonProps
    } = t0);
    $[0] = t0;
    $[1] = buttonProps;
    $[2] = isOpen;
    $[3] = pricing;
    $[4] = ref;
  } else {
    buttonProps = $[1];
    isOpen = $[2];
    pricing = $[3];
    ref = $[4];
  }
  const isMutating = useIsCartMutating();
  const {
    grandTotal,
    preDiscountGrandTotal
  } = pricing;
  const showStrikethrough = preDiscountGrandTotal !== undefined && preDiscountGrandTotal !== grandTotal;
  const t1 = isOpen && "rotate-180";
  let t2;
  if ($[5] !== t1) {
    t2 = cn("text-muted-foreground transition-transform", t1);
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <IconChevronDown size={16} className={t2} />;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-bold">Estimated Total</span>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = <span className="flex items-center space-x-3">{t3}{t4}</span>;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== grandTotal || $[13] !== isMutating || $[14] !== preDiscountGrandTotal || $[15] !== showStrikethrough) {
    t6 = isMutating ? <Skeleton className="h-5 w-20 bg-neutral-200" /> : <span className="flex items-center space-x-3">{showStrikethrough && <span className="text-neutral-500 line-through text-sm">{CurrencyFormatter.formatUSD(preDiscountGrandTotal)}</span>}<span className="font-bold">{CurrencyFormatter.formatUSD(grandTotal)}</span></span>;
    $[12] = grandTotal;
    $[13] = isMutating;
    $[14] = preDiscountGrandTotal;
    $[15] = showStrikethrough;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== buttonProps || $[18] !== ref || $[19] !== t5 || $[20] !== t6) {
    t7 = <button ref={ref} type="button" {...buttonProps} className="flex w-full items-center justify-between bg-neutral-100 px-4 py-3">{t5}{t6}</button>;
    $[17] = buttonProps;
    $[18] = ref;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}